<template>
  <v-container fluid class="pa-0">
    <!-- App Bar -->
    <v-app-bar dark flat class="gradient-app-bar">
      <v-toolbar-title>Settings</v-toolbar-title>
    </v-app-bar>

    <!-- Profile Section -->
    <v-container class="py-8">
      <v-card class="gradient-card pa-6 text-center">
        <v-avatar size="120">
          <v-img :src="profile.image || defaultImage" />
        </v-avatar>
        <h2 class="mt-4 font-weight-bold white--text">{{ profile.name || "User" }}</h2>
      </v-card>

      <!-- Settings Options -->
      <v-row justify="center" class="mt-8">
        <v-col cols="12" md="6">
          <v-list two-line dense class="settings-list">
            <v-list-item v-for="(item, index) in settingsItems" :key="index" @click="handleSettingClick(item.action)"
              class="hoverable">
              <v-list-item-avatar>
                <v-icon color="white">{{ item.icon }}</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-icon>
                <v-icon color="white">mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>

    <!-- Bottom Navigation -->
    <v-bottom-navigation app background-color="#3b5d58" grow dark>
      <v-btn icon to="/home">
        <span>
          <v-icon>mdi-home</v-icon>
          <p class="tab-label">Home</p>
        </span>
      </v-btn>
      <v-btn icon to="/search">
        <span>
          <v-icon>mdi-magnify</v-icon>
          <p class="tab-label">Search</p>
        </span>
      </v-btn>
      <v-btn icon to="/explore">
        <span>
          <v-icon>mdi-compass-outline</v-icon>
          <p class="tab-label">Explore</p>
        </span>
      </v-btn>
      <v-btn icon to="/messages">
        <span>
          <v-icon>mdi-message-text-outline</v-icon>
          <p class="tab-label">Messages</p>
        </span>
      </v-btn>
      <v-btn icon to="/groups">
        <span>
          <v-icon>mdi-account-group</v-icon>
          <p class="tab-label">Groups</p>
        </span>
      </v-btn>
      <v-btn icon to="/member-settings">
        <span>
          <v-icon>mdi-account</v-icon>
          <p class="tab-label">Profile</p>
        </span>
      </v-btn>
    </v-bottom-navigation>
  </v-container>
</template>

<script>
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "@/firebase";

export default {
  name: "MemberSettingsView",
  data() {
    return {
      profile: {
        image: "",
        name: "",
      },
      defaultImage: require("@/assets/logo.png"),
      settingsItems: [
        { title: "Calendar", icon: "mdi-calendar", action: "calendarInfo" },
        { title: "Personal Information", icon: "mdi-account-lock", action: "personalInfo" },
        { title: "Profile", icon: "mdi-account", action: "profileInfo" },
        { title: "Security Settings", icon: "mdi-lock-outline", action: "security" },
        { title: "Logout", icon: "mdi-logout", action: "logout" },
      ],
    };
  },
  methods: {
    async fetchProfile() {
      try {
        const userId = auth.currentUser.uid;
        const userRef = doc(db, "user", userId);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const data = userSnap.data();
          this.profile.name = data.fullName || "User";
          this.profile.image = data.image || "";
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },
    handleSettingClick(action) {
      if (action === "personalInfo") {
        this.$router.push({ name: "PersonalInformationView" });
      } else if (action === "profileInfo") {
        this.$router.push({ name: "Profile" });
      } else if (action === "calendarInfo") {
        this.$router.push({ name: "MemberCalendarView" });
      } else if (action === "security") {
        this.$router.push({ name: "SecuritySettingsView" });
      } else if (action === "logout") {
        this.logout();
      }
    },
    async logout() {
      try {
        await auth.signOut();
        this.$router.push("/");
      } catch (error) {
        console.error("Logout error:", error);
      }
    },
  },
  mounted() {
    this.fetchProfile();
  },
};
</script>


<style scoped>
.gradient-app-bar {
  background: linear-gradient(135deg, #f2c46d, #3b5d58);
}

.gradient-card {
  background: linear-gradient(135deg, #f2c46d, #3b5d58);
  color: white;
  border-radius: 20px;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);
}

.settings-list {
  background: linear-gradient(135deg, #f2c46d, #3b5d58);
  border-radius: 16px;
  padding: 8px;
}

.tab-label {
  font-size: 10px;
  margin-top: 2px;
  color: white;
}

.hoverable {
  transition: 0.3s;
  cursor: pointer;
}

.hoverable:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>